import { tv, type VariantProps } from '@workspace/lib';

export const tabsVariants = tv({
  slots: {
    list: 'mt-xl gap-lg md:gap-xl',
    tab: 'border-b-2 pb-3 font-heading text-lg/5 hover:text-primary focus-visible:outline-primary',
  },
  variants: {
    isActive: {
      true: {
        tab: 'border-primary font-bold text-primary',
      },
      false: {
        tab: 'border-transparent font-normal text-secondary-400',
      },
    },
  },
  defaultVariants: {
    isActive: false,
  },
});

export type TabsVariants = VariantProps<typeof tabsVariants>;
